module.exports = __webpack_public_path__ + "img/pin-fill.8f7c1881.svg";